import { AntdList, Avatar, Button, Empty, Icons, Input, Show } from "@pankod/refine-antd";
import { IResourceComponentsProps, useCustomMutation, useGetIdentity } from "@pankod/refine-core";
import { IUser, chatModel } from "interfaces";
import { useState } from "react";
import { API_AI, API_PATH, HELIUM_LOGO_PATH, OPENAI_LOGO_PATH, RESOURCE_PATH } from "scripts/site";
const { Search } = Input;

export const ChatList: React.FC<IResourceComponentsProps> = () => {
  const [chatData, setChatData] = useState<chatModel[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const { mutate } = useCustomMutation();
  const [inputValue, setInputValue] = useState('');

  const apiCall = (userText: string) => {
    setIsLoading(true);
    // Clear the chat history if there were any errors occured
    if (chatData.some(c => c.error)) {
      chatData.splice(0);
      setChatData(chatData);
    }

    chatData.push({
      actor: "user",
      conversation: {
        contextual: userText,
        standard: userText
      },
      error: false
    });
    setChatData(chatData);
    //setConversationText("");    
    setInputValue('');

    mutate({
      url: API_PATH + API_AI + "/" + RESOURCE_PATH.CHAT,
      method: "post",
      values: {
        chatContext: chatData,
        query: userText
      }
    },
      {
        onSuccess: (data, variables, context) => {
          chatData.push({
            actor: "assistant",
            conversation: {
              contextual: data?.data?.contextual,
              standard: data?.data?.standard,
            },
            error: false
          });
          setChatData(chatData);
          setIsLoading(false);
        },
        onError: (data, variables, context) => {
          //if (data.statusCode === 403) {
          chatData.push({
            actor: "assistant",
            conversation: {
              contextual: data?.statusCode + " - " + data?.response?.statusText + ": " + data?.response?.data,
              standard: data?.statusCode + " - " + data?.response?.statusText + ": " + data?.response?.data,
            },
            error: true
          });
          setChatData(chatData);
          setIsLoading(false);
          //}
        }
      }
    );
  }

  const { data } = useGetIdentity();
  const userObj = data as IUser;
  const imageUrl = userObj?.userImages?.find(img => img.uid === userObj?.userProfileImage)?.url;

  return (
    <Show
      canDelete={false}
      headerProps={{
        backIcon: false,
        title: "Chat GPT",
        extra: chatData.length > 0 && <Button danger icon={<Icons.ClearOutlined />} onClick={() => { setChatData([]) }}>Clear</Button>
      }}>

      <div
        id="scrollableDiv"
        style={{
          maxHeight: 500,
          overflow: 'auto',
          marginBottom: 20,
          //padding: '0 16px',
          //border: '1px solid rgba(140, 140, 140, 0.35)',
        }}
      >
        {chatData.length > 0 ?
          <AntdList
            loading={isLoading}
            itemLayout="vertical"
            pagination={false}
            dataSource={chatData}
            renderItem={(item) => (
              item.actor === "assistant"
                ? <AntdList.Item style={{ border: "none" }}>
                  <AntdList.Item.Meta
                    avatar={<Avatar src={OPENAI_LOGO_PATH} />}
                    title={"GPT-4"}
                    description={item.conversation.standard} />
                </AntdList.Item>
                : <AntdList.Item style={{ border: "none" }}>
                  <AntdList.Item.Meta
                    avatar={<Avatar src={imageUrl || HELIUM_LOGO_PATH} />}
                    title={userObj?.name ?? userObj.id}
                    description={item.conversation.standard} />
                </AntdList.Item>
            )}
          >
          </AntdList>
          : <Empty description="No conversations" image={Empty.PRESENTED_IMAGE_DEFAULT}></Empty>}
      </div>
      {/* <Space.Compact block>
      <Input style={{ width: 'calc(100% - 200px)' }} defaultValue="https://ant.design" />
      <Button type="primary">Submit</Button>
    </Space.Compact> */}
      <Search
        placeholder="Ask me anything"
        enterButton={<>Send  <Icons.SendOutlined /> </>}
        size="large"
        loading={isLoading}
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onSearch={apiCall}
      />
    </Show>
  );
};